/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Frail_Caring_Haddock_EngageInputs */

const fr_frail_caring_haddock_engage = /** @type {(inputs: Frail_Caring_Haddock_EngageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changer d'image`)
};

/**

* @param {Frail_Caring_Haddock_EngageInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const frail_caring_haddock_engage = /** @type {((inputs?: Frail_Caring_Haddock_EngageInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Frail_Caring_Haddock_EngageInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_frail_caring_haddock_engage(inputs)
});